module.exports = __webpack_public_path__ + "static/media/pos_order_printing.9232b005.jpg";